
  import { ADDRESS_FIELDS } from '@/constants/addresses';
  import { COOKIE_BROADBAND_SEARCH } from '@/constants/cookies';
  import { createBroadbandSearch } from '@/graphql/mutations/broadband';
  import { Address } from '@/scripts/address';
  import { mapGetters } from 'vuex';
  import compact from 'lodash/compact';
  import omit from 'lodash/omit';

  export default {
    props: {
      buttonText: { type: String, required: true },
      disableAutoFocus: { type: Boolean, default: false },
      searchLabel: { type: String, required: true }
    },
    data () {
      return {
        address: null,
        editProfile: false,
        addressFields: ADDRESS_FIELDS,
        formDisabled: false,
        bundleIncludes: ['Broadband']
      };
    },
    computed: {
      ...mapGetters('order', { order: 'get' }),
      ...mapGetters('providers', { providers: 'getList' }),
      ...mapGetters('search', { search: 'get' }),
      ...mapGetters('user', { canShowUserAddressCard: 'canShowUserAddressCard', customer: 'getCustomer', user: 'get' }),
      ...mapGetters('utils', { addressGetter: 'getAddress' }),
      showUserProfileCard () {
        return !this.editProfile && this.canShowUserProfileCard;
      },
      canonicalAddress () {
        return this.address ? new Address(this.address).canonical : null;
      },
      formattedAddressParts () {
        if (this.canonicalAddress) {
          return compact(this.addressFields.map((field, index) => {
            const part = this.canonicalAddress[field === 'eircode' ? 'displayEircode' : field];
            if (part) {
              return {
                text: part,
                class: index < this.addressFields.length - 2 ? 'bold' : 'light'
              };
            }
            return null;
          }));
        }
        return [];
      },
      formParams () {
        const bundles = this.bundleIncludes.reduce((obj, item) => {
          obj[item] = true;
          return obj;
        }, {});
        return {
          ...bundles,
          current_provider: this.search.current_provider || null,
          include_wireless: true,
          speed: 'all_speeds',
          address_attributes: omit(this.canonicalAddress, ['displayEircode'])
        };
      },
      storedAddress () {
        return this.addressGetter();
      }
    },
    watch: {
      storedAddress (val) {
        if (val) {
          this.address = val;
        }
      }
    },
    created () {
      if (this.canShowUserAddressCard) {
        this.$store.commit('utils/setAddress', this.customer.supply_address);
        this.address = this.customer.supply_address;
      }
    },
    methods: {
      editAddress () {
        this.address = null;
        this.editProfile = true;
      },
      proceed () {
        if (!this.bundleIncludes.length || !this.address.eircode) return;

        this.formDisabled = true;
        const params = this.formParams;
        this.$apolloMutate(createBroadbandSearch, { params }).then(search => {
          this.$cookies.set(COOKIE_BROADBAND_SEARCH, search.code);
          this.$router.push(this.localePath('/compare-tv-broadband-phone/your-results/'));
        }).catch(e => {
          console.error(e);
          this.formDisabled = false;
        });
      },
      updateSelectedItems (newVal) {
        this.bundleIncludes = newVal;
      }
    }
  };
